import React from 'react';

import { Languages, useLanguageState } from 'contexts/language/language-context';

import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import RadioSelectItem from '../../../components/radio-select-item';
import Select from '../../../components/select';

type ChangeLanguageProps = {
  dark?: boolean;
  fullWidth?: boolean;
};

const ChangeLanguage: React.FC<ChangeLanguageProps> = ({ dark = false, fullWidth = false }) => {
  const { language, changeLanguage } = useLanguageState();
  const intl = useIntl();

  return (
    <Select
      dark={dark}
      fullWidth={fullWidth}
      label={intl.formatMessage({ id: 'general.language' })}
      value={language}
      onChange={(event) => {
        changeLanguage(event.target.value as Languages);
      }}>
      <RadioSelectItem value={'en'} selected={language === 'en'}>
        <Typography fontSize={16}>English</Typography>
      </RadioSelectItem>
      <RadioSelectItem value={'nb'} selected={language === 'nb'}>
        <Typography fontSize={16}>Norsk</Typography>
      </RadioSelectItem>
      <RadioSelectItem value={'es'} selected={language === 'es'}>
        <Typography fontSize={16}>Español</Typography>
      </RadioSelectItem>
      <RadioSelectItem value={'vn'} selected={language === 'vn'}>
        <Typography fontSize={16}>Tiếng việt</Typography>
      </RadioSelectItem>
    </Select>
  );
};

export default ChangeLanguage;
